import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPPOptInModal: FunctionComponent = () => {
  const PPOptInModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-opt-in-modal" */ './PPOptInModal'
      ),
    { namedImport: 'PPOptInModal', preload: false },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <PPOptInModal />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
